export class Meta {
  idMeta : number;
  idArea : number;
  MontoReal : number = 0;
  MontoProyectado : number = 0;
  MontoDiferido : number = 0;
  FechaInicio : string;
  FechaFin : string;
  Plazo : number = 0;
  Estado : number;
}